import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { cn } from "../../lib/utils";

const slides = [
  { src: "/hero/01-bancada.jpg", alt: "Portátil numa bancada de oficina" },
  { src: "/hero/02-circuito.jpg", alt: "Circuito electrónico em reparação" },
  { src: "/hero/03-portatil-aberto.jpg", alt: "Interior de um portátil com dissipador de cobre" },
  { src: "/hero/04-tecnico.jpg", alt: "Técnico a reparar um computador de secretária" },
  { src: "/hero/05-ecra-avariado.jpg", alt: "Ecrã de portátil avariado" },
  { src: "/hero/06-wifi.jpg", alt: "Substituição de placa Wi-Fi" },
  { src: "/hero/07-reparacao.jpg", alt: "Reparação de motherboard de portátil" },
  { src: "/hero/08-exploded.jpg", alt: "Componentes de um portátil em vista explodida" },
  { src: "/hero/09-desmontagem.jpg", alt: "Portátil desmontado com motherboard, teclado e disco" },
] as const;

const INTERVAL_MS = 4500;

function panFor(index: number) {
  const even = index % 2 === 0;
  return {
    initial: { opacity: 0, scale: 1.2, x: even ? "-6%" : "6%", y: even ? "0%" : "-3%" },
    animate: { opacity: 1, scale: 1.2, x: even ? "6%" : "-6%", y: even ? "-3%" : "0%" },
  };
}

export function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const pan = panFor(index);

  useEffect(() => {
    const id = window.setInterval(() => {
      setIndex((current) => (current + 1) % slides.length);
    }, INTERVAL_MS);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div
      className="pointer-events-none absolute inset-0 overflow-hidden"
      aria-roledescription="carousel"
      aria-label="Fotografias de reparação"
    >
      <AnimatePresence initial={false}>
        <motion.img
          key={slides[index].src}
          src={slides[index].src}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
          initial={pan.initial}
          animate={pan.animate}
          exit={{ opacity: 0 }}
          transition={{
            opacity: { duration: 0.8 },
            x: { duration: 5.2, ease: "linear" },
            y: { duration: 5.2, ease: "linear" },
            scale: { duration: 0 },
          }}
          loading={index === 0 ? "eager" : "lazy"}
        />
      </AnimatePresence>

      <div
        className="absolute inset-0 bg-gradient-to-r from-background/85 via-background/55 to-background/25"
        aria-hidden
      />
      <div
        className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent"
        aria-hidden
      />

      <div className="pointer-events-auto absolute bottom-6 left-0 right-0 z-10 flex justify-center gap-2 px-4">
        {slides.map((slide, i) => (
          <button
            key={slide.src}
            type="button"
            aria-label={`Fotografia ${i + 1} de ${slides.length}`}
            aria-current={i === index}
            className={cn(
              "h-2 rounded-full transition-all duration-300",
              i === index ? "w-8 bg-button shadow-[0_0_12px_rgb(2_132_199/0.28)]" : "w-2 bg-ink/35 hover:bg-ink/60",
            )}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </div>
  );
}
